import React from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './CommercialSolar.css';

// Import all necessary images
import GjPhoto from '../images/gj.png';
import NPhoto from '../images/n.png';
import HitechPhoto from '../images/hitech.jpeg';
import MPhoto from '../images/m.png';
import DrytechPhoto from '../images/drytech.jpeg';
import K1Photo from '../images/k1.jpeg';
import PodarPhoto from '../images/podar.jpeg';
import LonawalaPhoto from '../images/lonawala.JPG';
import Sc3Photo from '../images/sc3.png';
import BeveragesPhoto from '../images/beverages.jpeg';
import DyPatilPhoto from '../images/dypatil.png';
import DyPatil2Photo from '../images/dypatil2.png';
import LukmanFruitsPhoto from '../images/Luc.png';
import MangalkaryalayPhoto from '../images/mangalkaryalay.jpeg';
import NarayanPhoto from '../images/narayan.png';
import KPhoto from '../images/k.jpeg';
import PolysterPhoto from '../images/polyster.jpeg';
import DeltinPhoto from '../images/Deltin.jpeg';
import DamanPhoto from '../images/Daman.jpeg';
import CommercialSola from '../images/commercial-solar.jpg';

// Projects array
const projects = [
  { img: GjPhoto, title: "Shree Sant Gajanan Maharaj, Shegaon (MH)", capacity: "3.2 MW Solar Capacity" },
  { img: NPhoto, title: "Gomashi, Shegaon", capacity: "Plant capacity 500 kw" },
  { img: HitechPhoto, title: "HITECH Shegaon", capacity: "Capacity 230kw" },
  { img: MPhoto, title: "Balaji Cranes", capacity: "Capacity 200kw" },
  { img: DrytechPhoto, title: "Drytech PVT LTD", capacity: "1.3 MW Capacity" },
  { img: K1Photo, title: "Kokan, Maharashtra", capacity: "Plant capacity 170MW" },
  { img: PodarPhoto, title: "Podar School", capacity: "100 kw" },
  { img: LonawalaPhoto, title: "Lonawala Project", capacity: "250 kw" },
  { img: Sc3Photo, title: "Bondri hospital,Shegaon", capacity: "500 kw" },
  { img: BeveragesPhoto, title: "Shrikrupa Beverages,Khamgaon", capacity: "90 kw" },
  { img: DyPatilPhoto, title: "DY Patil University", capacity: "200 kw" },
  { img: DyPatil2Photo, title: "DY Patil College", capacity: "150 kw" },
  { img: LukmanFruitsPhoto, title: "Lukman Fruits", capacity: "90 kw" },
  { img: MangalkaryalayPhoto, title: "Smarht MANGALKARYLAY,MUKTAINAGAR", capacity: "100 kw" },
  { img: NarayanPhoto, title: "Narayan Hotel,Malkapur", capacity: "75 kw" },
  { img: KPhoto, title: "Kokan,Maharashtra", capacity: "1.1 mw" },
  { img: PolysterPhoto, title: "Polyster Industry", capacity: "300 kw" },
  { img: DeltinPhoto, title: "Deltin Hotel", capacity: "400 kw" },
  { img: DamanPhoto, title: "Daman Site", capacity: "350 kw" },
  { img: CommercialSola, title:"Gajanan plastic ,malkapur", capacity: "250 kw" },
];

const CommercialSolar = () => {
  return (
    <>
      <section id="commercial-solar" className="py-5">
        <div className="container">
          <h1 className="commercial-solar-heading">
            Commercial Solar Projects
          </h1>

          <div className="row gy-5"> {/* gap between rows */}
            {projects.map((project, index) => (
              <div className="col-lg-6" key={index}>
                <div className="commercial-card">
                  <div
                    className="commercial-card-image"
                    style={{ backgroundImage: `url(${project.img})` }}
                  ></div>
                  <div className="commercial-card-text">
                    <h3>{project.title}</h3>
                    <p>{project.capacity}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CommercialSolar;
